import Vue from "vue";
import Vuex from "vuex";
import { getPermission } from "@/api/user";
// import { departmentList,supplierList } from "@/api/config.js";
import { MAX_PAGE_SIZE } from "@/utils/const.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "", // 用户登录凭证
    userInfo: null, // 用户信息
    userPermissions: [], // 用户权限码列表，如 ["admin.xxx", "admin.yyy"]
    departmentList: [], //部门，公共
    supplierList: [],// 供应商信息，公共
  },
  mutations: {
    // 设置 token
    setToken(state, token) {
      state.token = token;
    },
    // 设置用户信息
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    // 设置权限列表
    SET_USER_PERMISSIONS(state, list) {
      state.userPermissions = list;
    },
    //设置部门
    SET_DEPARTMENT_LIST(state, list) {
      state.departmentList = list;
    },
    //设置供应商
    SET_SUPPLIER_LIST(state, list) {
      state.supplierList = list;
    },
  },
  getters: {
    // 获取 token
    token: (state) => state.token,

    // 获取用户信息
    userInfo: (state) => state.userInfo,

    // 获取权限列表
    userPermissions: (state) => state.userPermissions,

    // 判断是否已登录（token 存在）
    isLoggedIn: (state) => !!state.token,

    // 判断是否拥有某个权限 code
    hasPermission: (state) => (code) => {
      return state.userPermissions.includes(code);
    },
  },

  actions: {
    // 异步获取权限列表
    getCodeList({ commit }) {
      return getPermission().then((res) => {
        const permissionData = (res || []).map((item) => ({
          ...item,
          id: Number(item.id),
          parentId: Number(item.parentId),
        }));
        // 存储进入
        localStorage.setItem("user_permissions", JSON.stringify(permissionData));
        commit("SET_USER_PERMISSIONS", permissionData);
        return res; // 方便链式调用
      });
    },
    getDepartmentPage({ commit }) {
      // return departmentList({
      //   pageNo: 1,
      //   pageSize: MAX_PAGE_SIZE,
      // }).then((res) => {
      //   commit("SET_DEPARTMENT_LIST", res.records || []);
      //   return res;
      // });
    },
    // 获取供应商
    getSupplierList({ commit }) {
      // return supplierList({
      //   pageNo: 1,
      //   pageSize: MAX_PAGE_SIZE,
      // }).then((res) => {
      //   commit("SET_SUPPLIER_LIST", res.records || []);
      //   return res;
      // });
    },
    
  },
});
